import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid} from '../question-helper';
import {QuestionType} from '../../constants';
import {Profession} from '../../models/Profession';
import {Industry} from '../../models/Industry';



declare const $: any;
declare const easyAutocomplete: any;

@Component({
    selector: 'app-question-checkbox-search-list',
    templateUrl: './question-checkbox-search-list.component.html',
    styleUrls: ['./question-checkbox-search-list.component.scss'],
    standalone: false
})
export class QuestionCheckboxSearchListComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() items: any[];
  @Input() placeHolder = 'Profession';
  @Input() inputType = 'text';
  @Input() value: any;
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlId = `textbox-checkbox-search-list-${newGuid()}`;
  uniqueControlName = `textbox-checkbox-search-list-${newGuid()}`;

  QuestionTypes = QuestionType;
  professions: Profession[] = [];
  industries: Industry[] = [];
  options: any[] = [];  
  selectedItems: any[] = [];
  constructor(private globalQuestionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    //this.startSpinner(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      if (this.question) {
        if (this.question?.question_prompt) {
          this.placeHolder = this.question?.question_prompt;
        }
        this.selectedItems = this.question?.answer ? this.question.answer.split('|') : [];
        this.getData();
      }
    }
  }

  getData(): void {
    this.options = JSON.parse(this.question?.options || '[]');
    console.log(this.options);
    
  }

  onChange(item: any, event: any): void {
    console.log(item, event)
    if (this.selectedItems.some(x => x === item?.answer)) {
      const index = this.selectedItems.findIndex(x => x === item?.answer);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      }
    } else {
      this.selectedItems.push(item?.answer);
    }
    if (event.srcElement.checked && item?.answer.toLowerCase() === ('None of the above').toLowerCase()) {
      this.selectedItems = [];
      this.selectedItems.push(item?.answer);
    }
    console.log(this.selectedItems);
    this.submit();
  }

  submit(): void {
    console.log(this.selectedItems)
    if (this.selectedItems?.length && this.question) {
      this.question.answer = this.selectedItems.join('|');
      console.log(this.question)
      this.questionAnswer.emit(this.question);
    }
    else {
      this.question.answer = '';
      this.questionAnswer.emit(this.question);
    }
  }

  startSpinner(start: boolean): void {
    if (start) {
      //this.globalQuestionService.spinner(true);
    } else {
      this.globalQuestionService.spinner(false);
    }
  }

 
}
